import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FeatureFlag } from "@/features/users/featureFlags";

import { useAccess } from "../useAccess";

export const useFeatureFlagRedirect = (
  requiredFlags: FeatureFlag[],
  redirectTo: string,
) => {
  const { hasFeature } = useAccess();
  const navigate = useNavigate();

  useEffect(() => {
    const hasRequiredFlags = requiredFlags.every((flag) => hasFeature(flag));
    if (!hasRequiredFlags && redirectTo) {
      navigate(redirectTo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requiredFlags]);
};
